import { combineReducers } from 'redux'

//reducers
import commonManagement from './common'
import historyTradeManagement from './history-trade'
import marketplaceSettingsManagement from './marketplace-settings'
import poolsManagement from './pools'
import shopManagement from './shop'
import adminManagement from './admin'
import userManagement from './user'
import collaborationManagement from './collaboration'
import profileManagement from './profile'
import dashboardManagement from './dashboard'
import giftManagement from './gift'
import guildManagement from './guild'
import sectorManagement from './sector'
import blackListsManagement from './blackList'
import tournamentManagement from './tournament'
import whiteListsManagement from './whiteList'
import chatListsManagement from './chat'
import notificationsManagement from './notification'
import maintenancesManagement from './maintenances'
//combine reducers
export default combineReducers({
  commonManagement,
  historyTradeManagement,
  marketplaceSettingsManagement,
  shopManagement,
  poolsManagement,
  adminManagement,
  userManagement,
  collaborationManagement,
  profileManagement,
  dashboardManagement,
  giftManagement,
  guildManagement,
  sectorManagement,
  blackListsManagement,
  tournamentManagement,
  whiteListsManagement,
  chatListsManagement,
  notificationsManagement,
  maintenancesManagement,
})
